module.exports = __webpack_public_path__ + "img/order-step9-c.fe58cb05.png";